import { DAILY_GUESS_ROWS } from '../../constants/games/dailyGame';

export const getDailyGuessBucketNumbers = () =>
  Array.from({ length: DAILY_GUESS_ROWS }, (_, index) => index + 1);

export const createEmptyDailyGuessBuckets = () =>
  getDailyGuessBucketNumbers().reduce((buckets, guessNumber) => {
    buckets[guessNumber] = 0;
    return buckets;
  }, {});
